import { useEffect, useState } from 'react';
import { useIntl } from '@/react-intl';
import { useModuleStudio } from '../data/ModuleStudioDataProvider';
import RecreateSimulationAction from './RecreateSimulationAction';
import SimulationErrorPanel from './SimulationErrorPanel';

export default function AcceptedSimulationNotice({
  dossierId,
  version,
}: {
  dossierId: string;
  version: number;
}) {
  const { repository } = useModuleStudio(),
    intl = useIntl();
  const [older, setOlder] = useState(false),
    [error, setError] = useState<unknown>(null);
  useEffect(() => {
    if (typeof repository.listSimulations !== 'function') return;
    let active = true;
    void (async () => {
      try {
        const items = await repository.listSimulations(dossierId);
        if (active)
          setOlder(
            items.some(
              (item) =>
                item.source.version === null || item.source.version < version,
            ),
          );
      } catch (failure) {
        if (active) setError(failure);
      }
    })();
    return () => {
      active = false;
    };
  }, [repository, dossierId, version]);
  return (
    <>
      <SimulationErrorPanel error={error} />
      {older ? (
        <section
          role="status"
          className="rounded-md border border-info-solid bg-info-subtle p-3 text-info-text"
        >
          <p>
            {intl.formatMessage(
              { id: 'moduleStudio.simRefresh.accepted' },
              { version },
            )}
          </p>
          <RecreateSimulationAction dossierId={dossierId} version={version} />
        </section>
      ) : null}
    </>
  );
}
